const getErrorNotFoundConfigProperty = (propertyName: string): string => {
  return `Свойство «${propertyName}» не найдено в параметрах конфигурации`;
};

export default getErrorNotFoundConfigProperty;
